// for loominguraamatukogu

function setFallbackColor(variableName, fallbackValue) {
    const rootStyles = getComputedStyle(document.documentElement);
    const variableValue = rootStyles.getPropertyValue(variableName).trim();

    if (!variableValue) {
        document.documentElement.style.setProperty(variableName, fallbackValue);
    }
}

export { setFallbackColor };
